__turbopack_context__.v({
  "textButton--login": "UAZmxq_textButton--login",
  "textButton--signup": "UAZmxq_textButton--signup",
});
